import { z } from 'zod';

import { BaseLoanEvent } from './BaseLoanEvent';

export const SendGracePastDueEmailEvent = BaseLoanEvent.extend({
  type: z.literal('sendGracePastDueEmail'),
});
export type SendGracePastDueEmailEvent = z.infer<typeof SendGracePastDueEmailEvent>;
